import { IVoucherHolderForList } from '@nkr/models/index';
import { CenterGridWrapper } from './styles';
import { GridReadyEvent } from 'ag-grid-community';
import CommonList from './common-list';

interface IProps {
    isAdminLogin: boolean,
    centerId: number,
    list: IVoucherHolderForList[],
    isLoading: boolean,
    groupByDonor: boolean,
    onOrderBuccalSwabKit: (id: number) => void,
    onOrderLabScreening: (id: number) => void,
    onReorderLabScreening: (id: number) => void,
    onUploadVoucherConsent: (id: number) => void,
    onUploadSwabResults: (id: number) => void,
    onUploadScreeningResults: (id: number) => void,
    onResendLink: (id: number) => void,
    onDownload: (voucherHolderId: number, docType: number) => void
    onLoadingComplete: () => void,
    onGridReady: (e: GridReadyEvent) => void
}

const CenterVoucherHolderList = (props: IProps) => {
    return (
        <CenterGridWrapper className='ag-theme-bootstrap'>
            <CommonList
                list={props.list}
                centerId={props.centerId}
                isAdmin={false}
                isAdminLogin={props.isAdminLogin}
                isLoading={props.isLoading}
                groupByDonor={props.groupByDonor}
                onOrderBuccalSwabKit={props.onOrderBuccalSwabKit}
                onOrderLabScreening={props.onOrderLabScreening}
                onReorderLabScreening={props.onReorderLabScreening}
                onUploadVoucherConsent={props.onUploadVoucherConsent}
                onUploadSwabResults={props.onUploadSwabResults}
                onUploadScreeningResults={props.onUploadScreeningResults}
                onResendLink={props.onResendLink}
                onDownload={props.onDownload}
                onLoadingComplete={props.onLoadingComplete}
                onGridReady={props.onGridReady}
            />
        </CenterGridWrapper>
    );
}

export default CenterVoucherHolderList;